// extracted by mini-css-extract-plugin
export default {"wrap":"benefits-section_wrap__xGAmC","columns":"benefits-section_columns__soqTT"};